/**
 * @generated SignedSource<<36ca707b1363faa21ca15b428ba69ad9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type GLOBAL_FILTER_FIELD = "COMPANY_TASK_ID" | "NAME" | "STATUS" | "PROJECT_STATUS" | "PROJECT_GROUP_STATUS" | "PROJECT_PHASE" | "PROJECT_SPRINT" | "PROJECT_GROUP_SPRINT" | "DESCRIPTION" | "REMAINING" | "TIME_REGS" | "FORECAST" | "TASK_APPROVED" | "START_DATE" | "START_DATE_PROJECT" | "END_DATE" | "END_DATE_PROJECT" | "START_DATE_TIME_REG" | "PHASE_TIME_REG" | "END_DATE_TIME_REG" | "PROJECT_TIME_REG" | "ROLE_TIME_REG" | "TEAM_TIME_REG" | "DEPARTMENT_TIME_REG" | "INTERNAL_TIME_REG" | "TIME_OFF_TIME_REG" | "BILLABLE_TIME_REG" | "NON_PROJECT_TIME_REG" | "NON_PHASE_TIME_REG" | "NON_TASK_TIME_REG" | "NON_CLIENT_TIME_REG" | "NON_DEPARTMENT_TIME_REG" | "NON_ROLE_TIME_REG" | "NON_SPRINT_TIME_REG" | "PERSON_TIME_REG" | "CLIENT_TIME_REG" | "SPRINT_TIME_REG" | "LABEL_TIME_REG" | "TASK_TIME_REG" | "CREATED_AT" | "WITH_TIME_REG" | "WITH_TASKS" | "TASK" | "TASK_LEVEL" | "UPDATED_AT" | "SET_DONE_AT" | "ASSIGNED" | "ASSIGNED_SELF" | "OWNER" | "FOLLOWER" | "LABELS" | "PROJECT_LABELS" | "ROLE" | "PROJECT" | "PROJECT_PERSON" | "CLIENT" | "PROJECT_STAGE" | "BUG" | "BLOCKED" | "BILLABLE" | "HIGH_PRIORITY" | "STARRED" | "RECENT_TIME" | "RECENT_TASK_ACTIVITY" | "RECENT_ACTIVITY" | "PHASE_CATEGORY" | "SPRINT_CATEGORY" | "DEADLINE" | "OWN_START_DATE" | "OWN_DEADLINE" | "TEAM_MEMBER" | "TEAM" | "PERMISSION_LEVEL" | "CLIENT_GUEST_USERS" | "DEPENDENCIES" | "SUB_TASKS" | "TASK_HIERARCHY" | "DEPARTMENT" | "PERSON" | "NO_CONTACT" | "APPROVAL_STATUS" | "INTERNAL_TIME" | "TIME_OFF" | "PROJECT_FOLLOWER" | "PROJECT_OWNER" | "PROJECT_BUDGET_TYPE" | "PROJECT_DEFAULT_PERIOD_BUDGET_TYPE" | "RATE_CARD" | "CONTACT" | "INVOICED" | "SKILL" | "PRIORITY_LEVEL" | "PROJECT_GROUP" | "PROGRAM" | "FILTER_BY_TIME_REG_SETTINGS" | "BILL_TO" | "BILL_FROM" | "PROJECT_MANUAL_PROGRESS" | "RETAINER_PERIOD" | "PROJECT_WIN_CHANCE" | "CLIENT_CONTACT_CLIENT_ID" | "CLIENT_CONTACT_COMPANY_ID" | "CLIENT_CONTACT_ID" | "CLIENT_CONTACT_NAME" | "CLIENT_CONTACT_FIRST_NAME" | "CLIENT_CONTACT_LAST_NAME" | "CLIENT_CONTACT_EMAIL" | "CLIENT_CONTACT_STATUS" | "CLIENT_CONTACT_IS_GUEST_USER" | "PHASE" | "SPRINT" | "DELIVERABLE" | "PARENT" | "PROGRESS" | "ESTIMATE" | "CREATED" | "UPDATED" | "%future added value";
export type GLOBAL_FILTER_OPERATOR = "IS" | "IS_NOT" | "IS_ALL" | "IS_NOT_ALL" | "CONTAINS" | "CONTAINS_NOT" | "GREATER" | "GREATER_OR_EQUAL" | "LESS" | "LESS_OR_EQUAL" | "IN" | "NOT_IN" | "ALL_IN" | "NOT_ALL_IN" | "%future added value";
export type REPORT_SORT_DIRECTION = "ASC" | "DESC" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type GenericSavedReportConductor_savedReport$data = {
  readonly id: string;
  readonly updatedAt: string | null;
  readonly updatedBy: {
    readonly id: string;
    readonly fullName: string | null;
  } | null;
  readonly type: string | null;
  readonly name: string | null;
  readonly person: {
    readonly id: string;
    readonly active: boolean | null;
    readonly email: string | null;
    readonly fullName: string | null;
    readonly profilePictureId: string | null;
  } | null;
  readonly groupingOne: string | null;
  readonly groupingTwo: string | null;
  readonly groupingThree: string | null;
  readonly groupingFour: string | null;
  readonly eyeApplied: string | null;
  readonly filterApplied: string | null;
  readonly filters: ReadonlyArray<{
    readonly field: GLOBAL_FILTER_FIELD | null;
    readonly value: ReadonlyArray<string | null> | null;
    readonly operator: GLOBAL_FILTER_OPERATOR | null;
  } | null> | null;
  readonly startDate: string | null;
  readonly endDate: string | null;
  readonly periodType: string | null;
  readonly periodDate: string | null;
  readonly reportService: boolean | null;
  readonly shares: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly user: {
          readonly id: string;
          readonly email: string | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
  readonly privateAccess: boolean | null;
  readonly state: string | null;
  readonly layout: ReadonlyArray<{
    readonly field: string | null;
    readonly width: number | null;
  } | null> | null;
  readonly sort: {
    readonly field: string | null;
    readonly direction: REPORT_SORT_DIRECTION | null;
  } | null;
  readonly " $fragmentType": "GenericSavedReportConductor_savedReport";
};
export type GenericSavedReportConductor_savedReport$key = {
  readonly " $data"?: GenericSavedReportConductor_savedReport$data;
  readonly " $fragmentSpreads": FragmentRefs<"GenericSavedReportConductor_savedReport">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "GenericSavedReportConductor_savedReport"
};

(node as any).hash = "27b9e7a9cc65dc40daf3c04006deb9b8";

export default node;
